export default __webpack_public_path__ + "static/media/Posterbg.ff067c7b.jpg";